import { render, staticRenderFns } from "./constructionEnterpriseDiagnosisResultDetail.vue?vue&type=template&id=b5a15774&scoped=true"
import script from "./constructionEnterpriseDiagnosisResultDetail.vue?vue&type=script&lang=js"
export * from "./constructionEnterpriseDiagnosisResultDetail.vue?vue&type=script&lang=js"
import style0 from "./constructionEnterpriseDiagnosisResultDetail.vue?vue&type=style&index=0&id=b5a15774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a15774",
  null
  
)

export default component.exports